import { bunja } from 'bunja';
import { atom } from 'jotai';
import { atomWithMutation } from 'jotai-tanstack-query';

import { getTranslatedCommunityFeedApi } from '@flipster/apis/v1/community';
import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';
import { getErrorCode } from '@flipster/utils/error';

import { authBunja } from '../../auth/state';
import { FeedItemScope } from '../post-and-edit/bunja';

export const feedCardBunja = bunja(() => {
  const store = bunja.use(JotaiStoreScope);
  const { isLoggedInAtom } = bunja.use(authBunja);
  const item = bunja.use(FeedItemScope);
  const statusAtom = atom<'VIEW' | 'EDIT'>('VIEW');
  const translatedAtom = atom<string | undefined>(undefined);
  const showTranslatedAtom = atom<boolean>(false);
  const translationMutationAtom = atomWithMutation(() => ({
    mutationFn: () => getTranslatedCommunityFeedApi(item.symbol, item.feedId, { lang: navigator.language }),
  }));
  async function getTranslation() {
    if (store.get(translatedAtom)) return store.set(showTranslatedAtom, true); // cache translation
    try {
      const response = await store.get(translationMutationAtom).mutateAsync();
      store.set(translatedAtom, response.data.translatedTextContent);
      store.set(showTranslatedAtom, true);
    } catch (e) {
      if (getErrorCode(e) === 'api.community.feed.translationError') {
        // show error?
      }
    }
  }
  const isTranslationLoadingAtom = atom((get) => get(translationMutationAtom).isPending);
  return {
    item,
    statusAtom,
    translatedAtom,
    showTranslatedAtom,
    getTranslation,
    isTranslationLoadingAtom,
    isLoggedInAtom,
  };
});
feedCardBunja.debugLabel = 'feedCardBunja';
